const SCORES = {
  SET_SCORES_QUERY: 'SET_SCORES_QUERY',
};

export default SCORES;
